document.addEventListener("DOMContentLoaded", () => {
  const hebrewFont = "'Rubik', sans-serif";
  const hebrewRegex = /[\u0590-\u05FF]/;

  const elements = document.querySelectorAll(".product-description *");

  elements.forEach(el => {
    const text = el.innerText || el.textContent;
    if (hebrewRegex.test(text)) {
      el.style.fontFamily = hebrewFont;
      el.style.textAlign = 'right'
    }
  });
});
